import React from 'react'
import * as S from './styles'
import { MainClipLoaderProps } from './types'
import { ClipLoader } from 'react-spinners'
import { useTheme } from 'styled-components'

export const Spinner = ({ offsetHeight, size = 100, fullScreen }: MainClipLoaderProps) => {
  const theme = useTheme()

  return (
    <S.Wrapper offsetHeight={offsetHeight} fullScreen={fullScreen}>
      <ClipLoader color={theme.colors.primary} size={size} />
    </S.Wrapper>
  )
}
